<template>
    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Tank Report Vengurla"  path="frontdash"/>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                            <div class="card-header">
                                <div class="row">
                                  
                                    <div class="col-md-2 col-12 position-relative"  >
                                        <label class="form-label">User Nagarpalika</label>
                                        <select class="form-select" required="" v-model="filter.np"  @change="getAgents($event)">
                                            <option selected=""   disabled="" value="0">Choose...</option>
                                            <template v-for="(item ,index)  in nagarpalika_list" :key="item.id">
                                                  <option :value="item.id">{{item.name}}</option>   
                                            </template> 
                                        </select>
                                    </div>
                                    
                                     <div class="col-md-2 col-12 position-relative"  >
                                        <label class="form-label">Agents</label>
                                        <select class="form-select" required="" v-model="filter.agent">
                                            <option selected=""   value="0">ALL</option>
                                            <template v-for="(item ,index)  in filter_agent_list" :key="item.id">
                                                  <option :value="item.id">{{item.empname}} ({{item.empcode}})</option>   
                                            </template> 
                                        </select>
                                    </div>
                                     <div class="col-md-2 col-12 position-relative">
                                            <label class="form-label">Ward Name</label>
                                            <select class="form-select" required="" v-model="filter.ward">
                                                <option selected="" value="0">ALL</option>
                                                <template v-for="(item ,index)  in filter_ward_list" :key="item">
                                                    <option :value="item.ward">{{item.ward}}</option>
                                                </template>
                                            </select>
                                        </div>
                                    
                                    <div class="col-xl-2 col-md-2 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">From Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.fromdate" >
                                    </div>
                                     <div class="col-xl-2 col-md-2 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">To Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.todate" >
                                    </div>
                                     <div class="col-xl-2 col-sm-12 col-12" >
                                        <button class="btn btn-primary" @click="filterReport"><i class="fa fa-filter"></i> Filter</button>
                                        
                                    </div>
                                </div>
                            </div>
                        <div class="card-body badge-spacing">
                            <div v-if="loading" >Data is Loading....</div>
                            <div v-else class="table-responsive custom-scrollbar">
                                <button class="dt-button buttons-csv buttons-html5" @click="exportKML()" v-if="userDetails.emprole!=4"> KML Report</button>
                                <table class="table display datatable" id="basic-1">
                                    <thead>
                                        <tr>
                                                <th>Sr.No</th>
                                             	<th>Survey Date</th>
                                                <th>Agent Name</th>
                                                <th>मालमत्ताधारकाचे नाव (Property Owner Name)</th>
                                                <th>वॉर्ड नं. (Ward No)</th>
                                                <th>मालमत्ता क्रमांक (Property Number)</th>
                                                <th>मोबाईल नंबर (Mobile Number)</th>
                                                <th>पत्ता (Address)</th> 
                                                <th>Tank Latitude</th> 
                                                <th>Tank Longitude</th> 
                                                <th>सांडपाणी सोडण्याची जागा (Wastewater Disposal)</th>
                                                <th>शौचालयांची संख्या (Toilet Count)</th>
                                                <th>टाकीची क्षमता (Tank Capacity)</th>
                                                <th>स्वच्छ भारत अनुदान (Swachh Bharat Grant)</th>
                                                <!--<th>टाकीचा प्रकार (Tank Type)</th>-->
                                                <th>सोकपिट जोडले आहे का (Soak Pit Connected)</th>
                                                <th>बांधकाम वर्ष (Construction Year)</th>
                                                <th>शेवटचा रिकामा केलेला दिनांक (Last Emptied Date)</th>
                                                <th>टाकीबद्दल इतर माहिती (Additional Info)</th>
                                                <th>Tank Image</th>
                                                <th class="hide">ID</th>
                                                <th>Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in treereports" :key="item.id" >
                                             <th>{{index+1}}</th>
                                             <th>{{item.iddate}}</th>
                                                <th>{{item.agent_name}}</th>
                                                <td>{{item.name}}</td>
                                                <td>{{item.ward}}</td>
                                                <td>{{item.property}}</td>
                                                <td>{{item.phone}}</td>
                                                <td>{{item.address}}</td> 
                                                <td>{{item.tank_location_lat}}</td> 
                                                <td>{{item.tank_location_lng}}</td> 
                                                <td>{{formatWastewaterDisposal(item.wastewater_disposal)}}</td>
                                                <td>{{item.toilet_count}}</td>
                                                <td>{{item.tank_capacity}}</td>
                                                <td>{{item.swachh_bharat_grant}}</td>
                                                <!--<td>{{item.tank_type}}</td>-->
                                                <td>{{item.soak_pit_connected}}</td>
                                                <td>{{item.construction_year}}</td>
                                                <td>{{item.last_emptied_date}}</td>
                                                <td>{{item.additional_info}}</td>
                                                <td class=""> 
                                                    <a :href="this.$hostname+''+item.tank_image" target="_blank" v-if="item.tank_image"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.tank_image}}</span>
                                                </td>
                                                <td class="hide">{{item.id}}</td>
                                                <td><span @click="editSurveyReport(item.id)" v-show="item.isEdit==1"><i class="fa fa-edit"></i></span></td>
                                                </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
 
</template>
<style scopped>
    th{
            text-transform: capitalize;
    }
    .table th, .table td{
        padding: 0.4em !important;
    }
    .hide{
        display: none;
    }
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue'; 
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'TankReportVengurla', 
    components: {
        PageTitle
    }, mounted() {
         if (this.$route.query.q) {
                this.getBasics(1);
            }else {
               this.getBasics(0);
            }
        

    }, data() {
        return {
          filter_agent_list: [],
          agent_list: [],
          nagarpalika_list: [],
                filter_ward_list: [],

                ward_list: [],
          treereports: [],
          treereports_full: [],
          fromDate: '',
          toDate: '',
          loading:true,
          userDetails:{"emprole":0},
          datatable:null,
          filter:{'np':'','agent':'','ward':'','fromdate':'','todate':''}
        }
    },
   
    methods: { 
        
        show_image(img){ 
            if(img) {
                window.open(this.$hostname+''+img, '_blank');
            }
        },
        
        formatWastewaterDisposal(wastewaterDisposal) {
            if (!wastewaterDisposal) return '';
            
            try {
                const disposal = typeof wastewaterDisposal === 'string' 
                    ? JSON.parse(wastewaterDisposal) 
                    : wastewaterDisposal;
                
                const options = [];
                if (disposal.septic_tank) options.push('सेप्टिक टाकीमध्ये');
                if (disposal.open_area) options.push('उघड्या जागेवर');
                if (disposal.drain) options.push('गटार मध्ये');
                if (disposal.other) options.push('इतर');
                
                return options.join(', ');
            } catch (e) {
                return wastewaterDisposal;
            }
        },
        
        getAgents(event){ 
             var np_id=event.target.value;
              if(this.agent_list)
                this.filter_agent_list=this.agent_list.filter(item => item.empdept === np_id);
               else 
                this.filter_agent_list =[];
             
              if(this.ward_list)
                this.filter_ward_list = this.ward_list.filter(item => item.nagarpalikaid === np_id);
              else 
                this.filter_ward_list =[];
             
              
        },
        filterReport() {
               var self = this; 
                self.loading=true;
                 axios.post('getTankSurveyVengurlaReport', { filter: self.filter })
                    .then(function (response) {
                         $(".datatable").DataTable().destroy();
                        self.treereports = response.data.survey_report; 
                        self.nagarpalika_list = response.data.nagarpalika_list; 
                         self.loading=false;
                    }).then(()=>{
                          if(self.userDetails.emprole==4){
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }else{
                         self.datatable= $(".datatable").DataTable({
                           dom: 'Bfrtip',
                           buttons: [  'excel', 'print','csv'],
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }
                    });
        },
        async getBasics(today) {
            var self = this;
            await  axios.post('getTankSurveyVengurlaReport',{today:today}).then(function (response) {
                // self.treereports = response.data.survey_report; 
                self.userDetails = response.data.userDetails;   
                self.nagarpalika_list = response.data.nagarpalika_list; 
                self.agent_list = response.data.agent_list; 
                self.ward_list = response.data.ward_list; 
                // self.treereports=self.treereports_full;//.slice(0, 1000);
                self.loading=false;
                window.scrollTo(0, 0);
            }).then(()=>{
                if(self.userDetails.emprole==4){
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }else{
                         self.datatable= $(".datatable").DataTable({
                           dom: 'Bfrtip',
                           buttons: [  'excel', 'print','csv'],
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }
            });
        },
        
        
        
        
        // exportKML(){ 
        //             var data = this.datatable.rows({ search: 'applied' }).data();
        //             var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
        //                       '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
        //                       '  <Document>\n'+
        //                       '<name>Tank Survey Vengurla</name>\n'+
        //                       '<description>Tank Survey Locations in Vengurla</description>\n';
    
        //             data.each(function (value, index) {
        //                 var name = value[3]; // Property Owner Name - Property Number
        //               var latlng = value[8] + ',' + value[9]; // Latitude, Longitude
    
        //       kml += '  	         <Placemark>\n'+
        //              '      				<name>\n'+
        //              '      					<![CDATA[Row: '+(1+index)+']]>\n'+
        //              '      				</name>\n'+
        //              "      				<Snippet maxLines='0'></Snippet>\n"+
        //              '      				<styleUrl>#0_0</styleUrl>\n'+
        //              '      				<ExtendedData></ExtendedData>\n'+
        //              '      				<LookAt>\n'+
        //              '      					<longitude>'+value[9]+'</longitude>\n'+
        //              '      					<latitude>'+value[8]+'</latitude>\n'+
        //              '      					<range>1000</range>\n'+
        //              '      					<altitudeMode>relativeToGround</altitudeMode>\n'+
        //              '      					<tilt>0</tilt>\n'+
        //              '      					<heading>0</heading>\n'+
        //              '      				</LookAt>\n'+
        //              '      				<Point>\n'+
        //              '      					<altitudeMode>clampToGround</altitudeMode>\n'+
        //              '      					<extrude>0</extrude>\n'+
        //              '      					<coordinates>'+latlng+',0</coordinates>\n'+
        //              '      				</Point>\n'+
        //              '      				<description>\n'+
        //              "      					<![CDATA[<style type='text/css'>*{font-family:Verdana,Arial,Helvetica,Sans-Serif;box-sizing:border-box;padding:0px;margin:0px}table{border-collapse:collapse;border-spacing:0px;margin:2px}.trb{background-color:#ddffdd}.ch{vertical-align:top;padding-left:10px;white-space:nowrap}.cv{vertical-align:top;padding-left:6px;padding-right:10px;white-space:nowrap}.cw{vertical-align:top;padding-left:6px;padding-right:10px;width:600px}</style><table><tr class='trb'><td class='ch'><b>Entry Id</b></td><td class='cv'>"+value[20]+"</td></tr><tr><td class='ch'><b>Survey Date</b></td><td class='cv'>"+value[1]+"</td></tr><tr class='trb'><td class='ch'><b>Agent Name</b></td><td class='cv'>"+value[2]+"</td></tr><tr><td class='ch'><b>Property Owner Name</b></td><td class='cv'>"+value[3]+"</td></tr><tr class='trb'><td class='ch'><b>Ward No</b></td><td class='cv'>"+value[4]+"</td></tr><tr><td class='ch'><b>Property Number</b></td><td class='cv'>"+value[5]+"</td></tr><tr class='trb'><td class='ch'><b>Mobile Number</b></td><td class='cv'>"+value[6]+"</td></tr><tr><td class='ch'><b>Address</b></td><td class='cv'>"+value[7]+"</td></tr><tr class='trb'><td class='ch'><b>Latitude</b></td><td class='cv'>"+value[8]+"</td></tr><tr><td class='ch'><b>Longitude</b></td><td class='cv'>"+value[9]+"</td></tr><tr><td class='ch'><b>Wastewater Disposal</b></td><td class='cv'>"+value[10]+"</td></tr><tr class='trb'><td class='ch'><b>Toilet Count</b></td><td class='cv'>"+value[11]+"</td></tr><tr><td class='ch'><b>Tank Capacity</b></td><td class='cv'>"+value[12]+"</td></tr><tr class='trb'><td class='ch'><b>Swachh Bharat Grant</b></td><td class='cv'>"+value[13]+"</td></tr><tr><td class='ch'><b>Tank Type</b></td><td class='cv'>"+value[14]+"</td></tr><tr class='trb'><td class='ch'><b>Soak Pit Connected</b></td><td class='cv'>"+value[15]+"</td></tr><tr><td class='ch'><b>Construction Year</b></td><td class='cv'>"+value[16]+"</td></tr><tr class='trb'><td class='ch'><b>Last Emptied Date</b></td><td class='cv'>"+value[17]+"</td></tr><tr><td class='ch'><b>Additional Info</b></td><td class='cv'>"+value[18]+"</td></tr><tr class='trb'><td class='ch'><b>ID</b></td><td class='cv'>"+value[20]+"</td></tr></table>]]>\n"+
                     
        //              '      				</description>\n'+
        //              '      			</Placemark> \n';
        //             });
    
        //             kml += '  </Document>\n' +
        //                   '</kml>';
    
        //             var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
        //             var link = document.createElement('a');
        //             link.href = window.URL.createObjectURL(blob);
        //             link.download = 'tank_survey_vengurla.kml';
        //             document.body.appendChild(link);
        //             link.click();
        //             document.body.removeChild(link);
        // },
        
       exportKML() {
    var data = this.datatable.rows({ search: 'applied' }).data();

    var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
              '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
              '  <Document>\n' +
              '    <name>Tank Survey Vengurla</name>\n' +
              '    <description>Tank Survey Locations in Vengurla</description>\n';

    data.each(function (value, index) {
        // Column order from your screenshot:
        // [0] Sr.No
        // [1] Survey Date
        // [2] Agent Name
        // [3] Property Owner Name
        // [4] Ward No
        // [5] Property Number
        // [6] Mobile Number
        // [7] Address
        // [8] Tank Latitude
        // [9] Tank Longitude
        // [10] Wastewater Disposal
        // [11] Toilet Count
        // [12] Tank Capacity
        // [13] Swachh Bharat Grant
        // [14] Soak Pit Connected
        // [15] Construction Year
        // [16] Last Emptied Date
        // [17] Additional Info
        // [18] Tank Image
        // [19] Edit (ignored)

        var name = value[3] + ' - ' + value[5]; // Property Owner Name - Property Number
        var lat = parseFloat(value[8]);
        var lon = parseFloat(value[9]);
        var latlng = lon + ',' + lat; // KML uses lon,lat order
            var imgCell = value[18];
            var imgUrl = '';
            
            if (imgCell) {
                // Extract href inside the hidden <a>
                var match = imgCell.match(/href="([^"]+)"/);
                if (match) imgUrl = match[1];
            }
            console.log(imgUrl)
        // skip invalid coordinates
        if (isNaN(lat) || isNaN(lon)) return;

        kml += '    <Placemark>\n' +
               '      <name><![CDATA[' + name + ']]></name>\n' +
               "      <Snippet maxLines='0'></Snippet>\n" +
               '      <styleUrl>#0_0</styleUrl>\n' +
               '      <LookAt>\n' +
               '        <longitude>' + lon + '</longitude>\n' +
               '        <latitude>' + lat + '</latitude>\n' +
               '        <range>1000</range>\n' +
               '        <altitudeMode>relativeToGround</altitudeMode>\n' +
               '        <tilt>0</tilt>\n' +
               '        <heading>0</heading>\n' +
               '      </LookAt>\n' +
               '      <Point>\n' +
               '        <altitudeMode>clampToGround</altitudeMode>\n' +
               '        <extrude>0</extrude>\n' +
               '        <coordinates>' + latlng + ',0</coordinates>\n' +
               '      </Point>\n' +
               '      <description><![CDATA[' +
               "<style type='text/css'>*{font-family:Verdana,Arial,Helvetica,Sans-Serif;box-sizing:border-box;padding:0;margin:0}table{border-collapse:collapse;margin:2px}.trb{background-color:#ddffdd}.ch{vertical-align:top;padding-left:10px;white-space:nowrap}.cv{vertical-align:top;padding-left:6px;padding-right:10px;white-space:nowrap}</style>" +
               "<table>" +
               "<tr class='trb'><td class='ch'><b>Sr.No</b></td><td class='cv'>" + value[0] + "</td></tr>" +
               "<tr><td class='ch'><b>Survey Date</b></td><td class='cv'>" + value[1] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Agent Name</b></td><td class='cv'>" + value[2] + "</td></tr>" +
               "<tr><td class='ch'><b>Property Owner Name</b></td><td class='cv'>" + value[3] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Ward No</b></td><td class='cv'>" + value[4] + "</td></tr>" +
               "<tr><td class='ch'><b>Property Number</b></td><td class='cv'>" + value[5] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Mobile Number</b></td><td class='cv'>" + value[6] + "</td></tr>" +
               "<tr><td class='ch'><b>Address</b></td><td class='cv'>" + value[7] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Tank Latitude</b></td><td class='cv'>" + value[8] + "</td></tr>" +
               "<tr><td class='ch'><b>Tank Longitude</b></td><td class='cv'>" + value[9] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Wastewater Disposal</b></td><td class='cv'>" + value[10] + "</td></tr>" +
               "<tr><td class='ch'><b>Toilet Count</b></td><td class='cv'>" + value[11] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Tank Capacity</b></td><td class='cv'>" + value[12] + "</td></tr>" +
               "<tr><td class='ch'><b>Swachh Bharat Grant</b></td><td class='cv'>" + value[13] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Soak Pit Connected</b></td><td class='cv'>" + value[14] + "</td></tr>" +
               "<tr><td class='ch'><b>Construction Year</b></td><td class='cv'>" + value[15] + "</td></tr>" +
               "<tr class='trb'><td class='ch'><b>Last Emptied Date</b></td><td class='cv'>" + value[16] + "</td></tr>" +
               "<tr><td class='ch'><b>Additional Info</b></td><td class='cv'>" + value[17] + "</td></tr>" +
               (value[18] ? "<tr class='trb'><td class='ch'><b>Tank Image</b></td><td class='cv'><a href='" +imgUrl+ "' target='_blank'>View Image</a></td></tr>" : "") +
               "</table>]]>\n" +
               '      </description>\n' +
               '    </Placemark>\n';
    });

    kml += '  </Document>\n</kml>';

    var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'tank_survey_vengurla.kml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
,

         editSurveyReport(item_id){
             this.$router.push({ name: "editsurvey" , query: { q: item_id} }); 
        }
         
    }
}
</script>